import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { Platform, ScrollView, StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import Colors from '../../constants/Colors';
import Languages from '../../constants/Languages';
import Layout from '../../constants/Layout';
import * as Actions from '../../store/Actions';
import Header from '../../components/register/Header';
import FilledButton from '../../components/FilledButton';
import MyFloatingLabelInput from '../../components/form/MyFloatingLabelInput';
import PtfKeyboardAvoidingView from '../../components/PtfKeyboardAvoidingView';

import { AppText } from '../../components/AppText';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.mediumBlue,
  },
  mainContentContainer: {
    flexGrow: 1,
    alignItems: 'center',
    backgroundColor: Colors.white,
  },
  topContainer: {
    alignItems: 'center',
  },
  emailContainer: {
    width: 328,
    marginTop: Layout.isSmall ? 80 : 100,
  },
  headingText: {
    fontSize: Layout.isSmall ? 20 : 26,
    fontWeight: '500',
    color: Colors.veryDarkGray,
    fontFamily: 'roboto-regular',
    textAlign: 'center',
    marginTop: Layout.isSmall ? 53 : 34,
  },
  form: {
    marginBottom: 16,
    padding: 0,
    paddingTop: 16,
    width: 345,
  },
  input: {
    marginTop: 49,
    fontSize: 16,
    lineHeight: 24,
    fontFamily: 'roboto-regular',
  },
  signupContainer: Layout.signupContainer,
  submitContainer: Layout.signupFooter,
  linkContainer: {
    paddingHorizontal: 16,
    paddingTop: Layout.isSmall ? 20 : 32,
    paddingBottom: 6,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: Layout.isSmall ? 'row' : 'column',
  },
  linkText: {
    fontSize: Layout.isSmall ? 14 : 16,
    marginBottom: 24,
    color: Colors.darkGreen,
    textDecorationLine: 'underline',
    textTransform: 'uppercase',
    fontWeight: '500',
  },
});

class ResetPasswordScreen extends Component {
  static propTypes = {
    registration: PropTypes.objectOf(PropTypes.any).isRequired,
    actions: PropTypes.objectOf(PropTypes.any).isRequired,
    navigation: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  constructor(props) {
    super();
    const { registration } = props;
    let email = '';
    if (get(registration, 'emailOrPhoneResult.email')) {
      email = registration.emailOrPhoneResult.email;
    } else if (get(registration, 'enterEmail.results.email')) {
      email = registration.enterEmail.results.email;
    }
    this.state = {
      email,
      isValid: this.validate(email),
    };
  }

  validate = (value) => {
    if (!value) return false;
    if (value.indexOf('@') !== -1 && value.indexOf('.') !== -1 && value.indexOf('.') < value.length - 2)
      return true;
  };

  goBack = () => {
    const { navigation } = this.props;
    navigation.navigate('EnterPassword');
  };

  goNext = () => {
    const { actions, navigation } = this.props;
    const { email } = this.state;

    actions.resetPassword(email, () => {
      navigation.navigate('ResetPasswordSent');
    });
  };

  onUpdateText = (text) => {
    const { actions, registration } = this.props;
    const { enterEmail } = registration;
    if (enterEmail.error) actions.clearEnterEmailError();
    const value = text.trim();
    const isValid = this.validate(value);
    this.setState({ email: value, isValid, emailError: null });
  };

  goToAnotherWay = () => {
    const { navigation } = this.props;
    navigation.navigate('PhoneOrEmail');
  };

  render() {
    const { registration } = this.props;
    const { email, isValid } = this.state;
    const { language } = registration;
    const translation = Languages.translations[language?.name || 'en'];

    return (
      <SafeAreaView style={{ flex: 1 }} edges={['top', 'left', 'right', 'bottom']}>
        <PtfKeyboardAvoidingView style={{ flex: 1 }}>
          <ScrollView
            keyboardShouldPersistTaps="handled"
            contentContainerStyle={styles.mainContentContainer}
            style={styles.container}
            testID="reset-password"
          >
            <Header title={translation.reset_password} goBack={this.goBack} />
            <View style={styles.signupContainer}>
              <View style={styles.topContainer}>
                <View style={styles.emailContainer}>
                  <AppText style={styles.headingText}>{translation.reset_password_text}</AppText>
                  <View style={styles.form}>
                    <AppText>{translation.reset_email_text}</AppText>
                    <MyFloatingLabelInput
                      label={translation.email_address}
                      style={styles.input}
                      onChangeText={this.onUpdateText}
                      onSubmitEditing={this.goNext}
                      keyboardType="email-address"
                      value={email}
                      width={328}
                      testID="email"
                    />
                  </View>
                </View>
              </View>
              <View style={styles.submitContainer}>
                <FilledButton
                  onPress={this.goNext}
                  label={translation.submit}
                  color={Colors.primaryColor}
                  full
                  textColor={Colors.white}
                  disabled={!isValid}
                  testID="button-submit"
                />
                <View style={styles.linkContainer}>
                  <AppText onPress={this.goToAnotherWay} style={styles.linkText}>
                    {translation.sign_in_another_way}
                  </AppText>
                </View>
              </View>
            </View>
          </ScrollView>
        </PtfKeyboardAvoidingView>
      </SafeAreaView>
    );
  }
}

function mapStateToProps(state) {
  return {
    registration: state.registration,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordScreen);
